// possibly move to mapistry-shared
const VERSIONED_SLUG_INDICATOR = '-v-';

function isFormTemplateSlugValid(slug: string) {
  return !slug.includes(VERSIONED_SLUG_INDICATOR);
}

export function isValidFormTemplateSlug(slug: string) {
  return isFormTemplateSlugValid(slug)
    ? undefined
    : `Slug cannot contain "${VERSIONED_SLUG_INDICATOR}"`;
}
